// extracted by mini-css-extract-plugin
export default {"wrapper":"Search_wrapper__jC8nN","search":"Search_search__Wncrn","SearchButton":"Search_SearchButton__uYeOm"};